import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, InputGroup, InputGroupAddon, FormFeedback, Input, Button } from "reactstrap";
import { isEmpty } from "lodash";
import { getDevices } from "../../api/devices";
import { getSim } from "../../api/simcards";
import { getTenant } from "../../api/tenants";
import { getVehicleByPlate } from "../../api/vehicles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createCollaudo } from "../../api/collaudo";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import PageLayout from "../../components/PageLayout";

const StartCollaudo = () => {
    const [collaudo, setCollaudo] = React.useState({});
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const { onSuccess, onError } = useAuth0();
    const [focused, setFocused] = React.useState("deviceScanBox");
    const { push } = useHistory()

    React.useEffect(() => {
        //console.log(focused);
        if (focused !== "-") {
            document.getElementById(focused).focus();
        }
    }, [focused]);

    const updateCollaudo = async (key, value) => {
        const newCollaudo = {
            ...collaudo,
            [key]: value
        };

        setCollaudo(newCollaudo);
        await validate(newCollaudo);
    };

    const getTenantandSimForDevice = async (dev) => {
        if (!dev.tenant_id || !dev.sim_id) return {
            number: " - ",
            tenant: {
                name: " - "
            }
        }
        const data = await Promise.all([
            getTenant(dev.tenant_id),
            getSim(dev.sim_id)
        ]);

        return {
            number: data[1].number,
            tenant: data[0]
        }
    }

    const getDevice = async () => {
        const imei = document.getElementById("deviceScanBox").value
        if (!imei) return;
        try {
            setLoading(true);
            const devicesResp = await getDevices([imei]);
            if (!devicesResp.length) {
                updateCollaudo("device", undefined);
            };
            const dev = devicesResp[0];

            const data = await getTenantandSimForDevice(dev);
            updateCollaudo("device", {
                ...dev,
                ...data
            });
        } finally {
            setLoading(false);
        }
    };

    const getVehicle = async () => {
        const plate = document.getElementById("plateScanBox").value
        if (!plate) return;
        try {
            setLoading(true);
            const veichResp = await getVehicleByPlate(plate);
            if (!veichResp) {
                updateCollaudo("vehicle", undefined);
            };

            updateCollaudo("vehicle", veichResp);
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setCollaudo({});
        setErrors({});
        setFocused("-");
        setLoading(false);
    };

    const validate = async coll => {
        let valErrors = {};
        if (!coll.device) {
            valErrors.device = `Dispositivo non trovato`;
        }

        if (coll.device && coll.device.status !== "consegnato") {
            valErrors.device = `Il dispositivo ${coll.device.imei} risulta essere in stato ${coll.device.status.toUpperCase()} e non nello stato CONSEGNATO e quindi non collaudabile.`;
        }

        if (!coll.vehicle) {
            valErrors.vehicle = `Selezionare un veicolo`;
        }

        if (
            coll.device &&
            coll.vehicle &&
            coll.device.tenant_id !== coll.vehicle.tenant_id
        ) {
            valErrors.vehicle = `Dispositivo e veicolo appartengono a Dealer diversi o il dispositivo non è ancora collaudabile.`;
        }

        setErrors(valErrors);
        return isEmpty(valErrors);
    };

    const onScanDevice = e => {
        if (e.key === "Enter") {
            getDevice();
        }
    };

    const onScanPlate = e => {
        if (e.key === "Enter") {
            getVehicle();
        }
    };

    const isValid = () => {
        return isEmpty(errors);
    };

    const saveData = async () => {
        try {
            const isValid = await validate(collaudo);
            if (!isValid) return;
            setLoading(true);
            const newCollaudo = await createCollaudo({
                device_id: collaudo.device._id,
                customer_id: collaudo.vehicle.customer_id,
                vehicle_id: collaudo.vehicle._id,
                attributes: {
                    tenant_id: collaudo.device.tenant_id,
                    sim_id: collaudo.device.sim_id,
                    tenant_name: collaudo.vehicle.tenant_name,
                    customer_name: collaudo.vehicle.customer_name,
                    customer_ticket: collaudo.vehicle.customer_ticket,
                    plate: collaudo.vehicle.plate.toUpperCase(),
                    frame: collaudo.vehicle.frame,
                    imei: collaudo.device.imei,
                    serial: collaudo.device.serial,
                    number: collaudo.device.number
                },
                meta: {
                    vehicle: collaudo.vehicle,
                    device: collaudo.device
                }
            });
            onSuccess();
            push(`/collaudo/test-dashboard/${newCollaudo._id}`)
        } catch (error) {
            onError();
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageLayout
            title="NUOVO COLLAUDO"
            optionalNav={{ link: "/collaudo/list", text: "Elenco Collaudi" }}
        >
            <Row>
                <Col sm="12" className="mt-1">
                    <strong className="mt-2">IMEI del dispositivo</strong>
                    <InputGroup>
                        <Input
                            id="deviceScanBox"
                            placeholder="inserire il codice IMEI del dispositivo"
                            maxLength={15}
                            onKeyPress={onScanDevice}
                            invalid={errors.device ? true : undefined}
                            valid={collaudo.device && !errors.device ? true : undefined}
                        />
                        <InputGroupAddon addonType="append">
                            <Button
                                color="info"
                                onClick={getDevice}
                            >
                                <FontAwesomeIcon icon={loading ? "circle-notch" : "search"}
                                    spin={loading} />
                            </Button>
                        </InputGroupAddon>
                        {errors.device && (
                            <FormFeedback invalid>{errors.device}</FormFeedback>
                        )}
                        {collaudo.device && !errors.device && (
                            <FormFeedback valid>
                                {`IMEI: ${collaudo.device.imei} - Seriale: ${collaudo.device.serial} - Numero: ${collaudo.device.number}  - Dealer: ${collaudo.device.tenant.name}`}
                            </FormFeedback>
                        )}
                    </InputGroup>
                </Col>
                <Col sm="12" className="mt-4">
                    <strong className="mt-2">Inserire la targa del veicolo</strong>
                    <InputGroup>
                        <Input
                            id="plateScanBox"
                            placeholder="inserire la targa del veicolo"
                            maxLength={15}
                            onKeyPress={onScanPlate}
                            invalid={collaudo.vehicle && errors.vehicle ? true : undefined}
                            valid={collaudo.vehicle && !errors.vehicle ? true : undefined}
                        />
                        <InputGroupAddon addonType="append">
                            <Button
                                color="info"
                                onClick={getVehicle}
                            >
                                <FontAwesomeIcon icon={loading ? "circle-notch" : "search"}
                                    spin={loading} />
                            </Button>
                        </InputGroupAddon>
                        {collaudo.vehicle && errors.vehicle && (
                            <FormFeedback invalid>{errors.vehicle}</FormFeedback>
                        )}
                        {collaudo.vehicle && !errors.vehicle && (
                            <FormFeedback valid>
                                {`Targa: ${collaudo.vehicle.plate} - Cliente: ${collaudo.vehicle.customer_name} - Cod. Centrale Operativa: ${collaudo.vehicle.customer_ticket || "N.D."}`}
                            </FormFeedback>
                        )}
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="mt-5">
                        <Button
                            className="mr-2 mb-2 float-left"
                            color="primary"
                            label="Torna"
                            onClick={() => {
                                history.go(-1);
                            }}
                        >
                            <FontAwesomeIcon icon="undo" /> Torna
                        </Button>
                        <div className="float-right">
                            <Button
                                className="mr-2 mb-2"
                                color="warning"
                                disabled={loading}
                                onClick={resetForm}
                            >
                                <FontAwesomeIcon icon="times" /> Annulla
                            </Button>
                            <Button
                                className="mb-2"
                                disabled={loading || !isValid()}
                                color="success"
                                onClick={saveData}
                            >
                                <FontAwesomeIcon icon="check" /> Inizia collaudo
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
};

export default StartCollaudo;
